import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import withRouter from "components/Common/withRouter";


import user1 from "../../assets/images/users/user-1.jpg";
// actions
import { result } from "lodash";
import { toast } from "react-toastify";
import { getSingleUser } from "helpers/user_helper";
import Loader from "components/Loader/Loader";

const UserProfile = () => {

  //meta title
  document.title = "Profile | Skote - React Admin & Dashboard Template";

  const dispatch = useDispatch();

  const [name, setname] = useState("");
  const [idx, setidx] = useState(1);
  const [spanDisplay, setSpanDisplay] = useState("none");
  const [user, setUser] = useState({});
  const [loader, setLoader] = useState(false);


  const fetchUser = async () => {
    try {
      setLoader(true);
      const id = JSON.parse(localStorage.getItem("authUser"))?.id;
      const data = await getSingleUser(id);
      if (data?.success) {
        setUser(data?.result[0]);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoader(false);
    }
  }


  useEffect(() => {
    fetchUser();
  }, []);


  const handleSubmit = async (e) => {


  }




  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser((prevUser) => ({
      ...prevUser,
      [name]: value
    }));
  };

  return (
    <React.Fragment>
      {loader ? (
        <Loader />
      ) : ("")}
      <div className="page-content p-0">
        <Container fluid>

          {/* <Row>
            <Col lg="12">
              {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">{success}</Alert> : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <img
                        src={user1}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{name}</h5>
                        <p className="mb-1">{email}</p>
                        <p className="mb-0">Id no: #{idx}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row> */}

          <h4 className="card-title mb-4">Update Profile</h4>

          <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={handleSubmit}
              >
                <div className="form-group mb-3">
                  <Label className="form-label">Name</Label>
                  <Input
                    name="name"
                    className="form-control"
                    placeholder="Enter Name"
                    type="text"
                    onChange={handleChange}
                    value={user?.name}

                  />
                  {!user?.name && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                </div>

                <div className="form-group mb-3">
                  <Label className="form-label">Email</Label>
                  <Input
                    name="Email"
                    className="form-control"
                    placeholder="Enter Email"
                    type="text"
                    onChange={handleChange}
                    value={user?.email}

                  />
                  {!user?.email && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                </div>
                <div className="form-group mb-3">
                  <Label className="form-label">Phone Number</Label>
                  <Input
                    name="Phone Number"
                    // value={name}
                    className="form-control"
                    placeholder="Enter Phone Number"
                    type="text"
                    onChange={handleChange}
                    value={user?.mobile}

                  />
                  {!user?.mobile && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                </div>
                {/* <div className="text-center mt-4">
                  <Button type="submit" color="danger">
                    Update Profile
                  </Button>
                </div> */}
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
